import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FileGlyph = /*#__PURE__*/createElement("g", {
  id: "file",
  stroke: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M64.6 27.2c0-.4-.2-.8-.5-1.1L52.5 15.4c-.3-.3-.6-.4-1-.4H25c-3.1 0-5.5 2.5-5.5 5.5v42.9c0 3.1 2.5 5.5 5.5 5.5h34c3.1 0 5.5-2.5 5.5-5.5l.1-36.2zm-11.7-7.3l6.2 5.8h-3.7c-1.4 0-2.5-1.1-2.5-2.5v-3.3zm6 46.2h-34c-1.4 0-2.5-1.1-2.5-2.5v-43c0-1.4 1.1-2.5 2.5-2.5h25v5.2c0 3.1 2.5 5.5 5.5 5.5h6v34.7c.1 1.4-1.1 2.6-2.5 2.6z"
}));
const File = createSvg({
  name: 'file',
  viewBox: '0 0 33 33',
  path: FileGlyph
});

export default File;
export { FileGlyph };
